// Webpack will replace 'logger-node' with 'logger-browser' in browser environments.
const { log } = require('./logger-node');

/**
 * The FATAL level designates very severe error events that will presumably lead the application to abort.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */
const fatal = (msg, data = null) => {
	log('FATAL', msg, data);
};

/**
 * The ERROR level designates error events that might still allow the application to continue running.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */
const error = (msg, data = null) => {
	log('ERROR', msg, data);
};

/**
 * The WARN level designates potentially harmful situations.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */
const warn = (msg, data = null) => {
	log('WARN', msg, data);
};

/**
 * The INFO level designates informational messages that highlight the progress of the application at coarse-grained level.
 * @param {[string, unknown][]} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */
const info = (msg, data = null) => {
	log('INFO', msg, data);
};

/**
 * The DEBUG level designates fine-grained informational events that are most useful to debug an application.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */
const debug = (msg, data = null) => {
	log('DEBUG', msg, data);
};

/**
 * The TRACE level designates finer-grained informational events than the DEBUG level.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */
const trace = (msg, data = null) => {
	log('TRACE', msg, data);
};

module.exports = {
	fatal,
	error,
	warn,
	info,
	debug,
	trace
};
